import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import SupplierProductColumn from "../../shared/component/dataTable/columns/SupplierProductColumn.json";
import SupplierProductUsageColumn from "../../shared/component/dataTable/columns/SupplierProductUsageColumn.json";
import DataTable from "../../shared/component/dataTable/DataTable";
import SupplierProductService from "../../shared/service/SupplierProductService";
import TextFormat from "../../shared/component/textFormat/TextFormat";
import Loading from "../../shared/component/others/Loading";
import {APP_DATE_FORMAT} from "../../shared/utils/Constants";
import '../../shared/styles/SettingsPage.css';
import '../../shared/styles/MasterDetailSave.css';

const defaultSupplierProduct = {
    id: '', bssId: '', supplierBssId: null, barcode: null, productCode: null, virtualProductCode: null, productName: null, tradingName: null, invoiceDate: null, confirmDate: null, matchStatus: null,
};

const MATCH_STATUS_OPTIONS = [
    {value: 'INITIAL', label: 'INITIAL'},
    {value: 'SELECTED', label: 'SELECTED'},
    {value: 'VERIFIED', label: 'VERIFIED'},
];

export default class SupplierProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            supplierProduct: defaultSupplierProduct,
            supplierProductTemp: defaultSupplierProduct,
            supplierProductDetailsSaveButtonRender: true,
            supplierProductList: [],
            usageList: [],
            usageLoading: false,
            displayRecalculateSelectionDialog: false,
            recalculateSelectionLoading: false,
        }
        this.supplierProductService = new SupplierProductService();
    }

    componentDidMount() {
        let obj1 = Object.assign({}, defaultSupplierProduct);
        this.setState({
            supplierProduct: obj1,
            supplierProductDetailsSaveButtonRender: false,
            supplierProductTemp: Object.assign({}, obj1)
        });
        this.refresh();
    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                {this.state.recalculateSelectionLoading && <Loading label="Recalculating selection..."/>}
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header settings-page__header--with-meta">
                            <h1 className="settings-page__title">Supplier Product</h1>
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action"
                                style={{minWidth: '12rem', whiteSpace: 'nowrap', flexShrink: 0}}
                                disabled={this.state.recalculateSelectionLoading}
                                onClick={() => this.setState({displayRecalculateSelectionDialog: true})}>
                                {this.state.recalculateSelectionLoading ? (
                                    <>
                                        <i className="pi pi-spin pi-spinner" style={{marginRight: '0.5rem'}}/>
                                        Please Wait...
                                    </>
                                ) : (
                                    'Recalculate Selection'
                                )}
                            </Button>
                        </div>
                        <div className="settings-page__panel master-detail-save">
                            {this.supplierProductDetails()}
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.supplierProduct.id)) {
            this.supplierProductService.delete(this.state.supplierProduct.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let obj1 = Object.assign({}, defaultSupplierProduct);
                        this.setState({
                            supplierProduct: obj1,
                            supplierProductDetailsSaveButtonRender: false,
                            supplierProductTemp: Object.assign({}, obj1)
                        });
                        this.refresh();
                    }
                });
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

    supplierProductDetails() {
        return (
            <>
                <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                              onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                              show={this.state.displayShowStatusConfirmDialog}
                              message={this.state.noticeResponse}/>

                <ModalConfirm header='Warning' ok='OK' onOkClick={this.recalculateSelection}
                              onCancelClick={() => this.setState({displayRecalculateSelectionDialog: false})}
                              show={this.state.displayRecalculateSelectionDialog}
                              message="Are you sure you want to recalculate selection?"/>

                <div className="master-detail-save__split">
                    <div className="master-detail-save__list">
                        <FormSection title="Supplier Products" className="master-detail-save__list-section">
                            <div className="settings-page__table-wrap master-detail-save__list-table">
                                <DataTable ref={(elem) => this.refDataTable = elem}
                                           fields={SupplierProductColumn.fields}
                                           objectName={SupplierProductColumn.name}
                                           data={this.state.supplierProductList}
                                           dataURL={"inventory/supplierProduct/all/global"}
                                           selectionMode="single"
                                           onDataSelect={this.onDataSelect}
                                           loading={this.state.recalculateSelectionLoading}/>
                            </div>
                        </FormSection>
                    </div>

                    <div className="master-detail-save__details">
                        <div className="master-detail-save__details-body">
                            <FormSection title="Supplier Product Details">
                                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__filter-row--wide settings-page__form-fields">
                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-barcode">
                                                <Translate contentKey="supplierProduct.tradingName">Barcode</Translate>
                                            </Label>
                                            <AvField
                                                id="supplier-product-barcode"
                                                type="text"
                                                className="form-control"
                                                name="barcode"
                                                disabled={!this.state.supplierProductDetailsSaveButtonRender}
                                                validate={{
                                                    maxLength: {
                                                        value: 255,
                                                        errorMessage: "You can enter up to 255 characters in this field."
                                                    }
                                                }}
                                                value={this.state.supplierProduct.barcode}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-code">
                                                <Translate contentKey="supplierProduct.tradingName">Product Code</Translate>
                                            </Label>
                                            <AvField
                                                id="supplier-product-code"
                                                type="text"
                                                className="form-control"
                                                name="productCode"
                                                disabled={!this.state.supplierProductDetailsSaveButtonRender}
                                                validate={{
                                                    maxLength: {
                                                        value: 255,
                                                        errorMessage: "You can enter up to 255 characters in this field."
                                                    }
                                                }}
                                                value={this.state.supplierProduct.productCode}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-virtual-code">
                                                <Translate contentKey="supplierProduct.tradingName">Virtual Product Code</Translate>
                                            </Label>
                                            <AvField
                                                id="supplier-product-virtual-code"
                                                type="text"
                                                className="form-control"
                                                name="virtualProductCode"
                                                disabled={!this.state.supplierProductDetailsSaveButtonRender}
                                                validate={{
                                                    maxLength: {
                                                        value: 255,
                                                        errorMessage: "You can enter up to 255 characters in this field."
                                                    }
                                                }}
                                                value={this.state.supplierProduct.virtualProductCode}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-name">
                                                <Translate contentKey="supplierProduct.tradingName">Product Name</Translate>
                                            </Label>
                                            <AvField
                                                id="supplier-product-name"
                                                type="text"
                                                className="form-control"
                                                name="productName"
                                                disabled={!this.state.supplierProductDetailsSaveButtonRender}
                                                validate={{
                                                    maxLength: {
                                                        value: 255,
                                                        errorMessage: "You can enter up to 255 characters in this field."
                                                    }
                                                }}
                                                value={this.state.supplierProduct.productName}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-trading-name">Trading Name</Label>
                                            <AvField
                                                id="supplier-product-trading-name"
                                                type="text"
                                                className="form-control"
                                                name="tradingName"
                                                disabled={true}
                                                value={this.state.supplierProduct.tradingName || ''}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-invoice-date">Invoice Date</Label>
                                            <div className="form-control" style={{backgroundColor: '#e9ecef', minHeight: '38px', display: 'flex', alignItems: 'center'}}>
                                                <TextFormat
                                                    value={this.state.supplierProduct.invoiceDate}
                                                    type="date"
                                                    format="DD/MM/YYYY"
                                                    blankOnInvalid/>
                                            </div>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-match-status">Match Status</Label>
                                            <AvField
                                                id="supplier-product-match-status"
                                                type="select"
                                                className="form-control"
                                                name="matchStatus"
                                                disabled={true}
                                                value={this.state.supplierProduct.matchStatus || ''}>
                                                <option value="">—</option>
                                                {MATCH_STATUS_OPTIONS.map((option) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </AvField>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="supplier-product-confirm-date">Confirm Date</Label>
                                            <div className="form-control" style={{backgroundColor: '#e9ecef', minHeight: '38px', display: 'flex', alignItems: 'center'}}>
                                                <TextFormat
                                                    value={this.state.supplierProduct.confirmDate}
                                                    type="date"
                                                    format={APP_DATE_FORMAT}
                                                    blankOnInvalid/>
                                            </div>
                                        </AvGroup>
                                    </div>
                                </div>
                            </FormSection>

                            <FormSection title="Branch Usages">
                                <div className="settings-page__table-wrap">
                                    <DataTable
                                        fields={SupplierProductUsageColumn.fields}
                                        objectName={SupplierProductUsageColumn.name}
                                        data={this.state.usageList}
                                        autoLoad={false}
                                        paginator={false}
                                        loading={this.state.usageLoading}
                                        selectionMode={null}
                                    />
                                </div>
                            </FormSection>

                            <div className="settings-page__actions master-detail-save__form-actions">
                                {false && this.state.supplierProductDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.supplierProduct.id) &&
                                    <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                        this.setState({supplierProductDetailsSaveButtonRender: true});
                                    }}>
                                        <Translate contentKey="entity.action.add">Edit</Translate>
                                    </Button>}

                                {false && this.state.supplierProductDetailsSaveButtonRender &&
                                    <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                        this.saveSupplierProduct();
                                    }}>
                                        <Translate contentKey="entity.action.add">Save</Translate>
                                    </Button>}

                                {false && this.state.supplierProductDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.supplierProduct.id) &&
                                    <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                        this.showChangeStatusConfirmDialog(true)
                                    }}>
                                        <Translate contentKey="entity.action.add">Delete</Translate>
                                    </Button>}

                                {this.state.supplierProductDetailsSaveButtonRender &&
                                    <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                        let obj1 = this.state.supplierProductTemp;
                                        this.setState({
                                            supplierProduct: Object.assign({}, obj1),
                                            supplierProductDetailsSaveButtonRender: false
                                        });
                                    }}>
                                        <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                    </Button>}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    recalculateSelection = () => {
        this.setState({displayRecalculateSelectionDialog: false, recalculateSelectionLoading: true});
        this.supplierProductService.recalculateSelection()
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.refresh();
                    const selectedId = this.state.supplierProduct?.id;
                    if (!GeneralUtils.isNullOrEmpty(selectedId)) {
                        this.reloadSelectedSupplierProduct(selectedId);
                    }
                }
            })
            .finally(() => {
                this.setState({recalculateSelectionLoading: false});
            });
    }

    reloadSelectedSupplierProduct = (id) => {
        this.setState({usageLoading: true});
        this.supplierProductService.findById(id).then(response => {
            this.setState({
                supplierProduct: response,
                supplierProductTemp: Object.assign({}, response)
            });
        });
        this.supplierProductService.findUsages(id).then(response => {
            this.setState({
                usageList: Array.isArray(response) ? response : [],
                usageLoading: false
            });
        }).catch(() => {
            this.setState({usageList: [], usageLoading: false});
        });
    }

    onDataSelect = (data) => {
        this.setState({usageLoading: true, usageList: []});
        this.supplierProductService.findById(data.id).then(response => {
            this.setState({
                supplierProduct: response,
                supplierProductDetailsSaveButtonRender: false,
                supplierProductTemp: Object.assign({}, response)
            });
        });
        this.supplierProductService.findUsages(data.id).then(response => {
            this.setState({
                usageList: Array.isArray(response) ? response : [],
                usageLoading: false
            });
        }).catch(() => {
            this.setState({usageList: [], usageLoading: false});
        });
    }

    saveSupplierProduct = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.supplierProduct.supplierBssId) || GeneralUtils.isNullOrEmpty(this.state.supplierProduct.barcode) || GeneralUtils.isNullOrEmpty(this.state.supplierProduct.virtualProductCode) || GeneralUtils.isNullOrEmpty(this.state.supplierProduct.productName)) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.supplierProduct.id)) {
                this.supplierProductService.update(this.state.supplierProduct)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierProductDetailsSaveButtonRender: false,
                                supplierProduct: response,
                                supplierProductTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            } else {
                this.supplierProductService.create(this.state.supplierProduct)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierProductDetailsSaveButtonRender: false,
                                supplierProduct: response,
                                supplierProductTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            }
        }
    }

    addNew() {
        let obj1 = Object.assign({}, defaultSupplierProduct);
        this.setState({
            supplierProduct: obj1,
            supplierProductDetailsSaveButtonRender: true,
            supplierProductTemp: Object.assign({}, obj1)
        });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let supplierProduct = this.state.supplierProduct;
        supplierProduct[e.target.name] = value;
        this.setState({supplierProduct: supplierProduct});
    }
}
